<template>
	<div class='tw-flex tw--mx-20'>
		<div class="px-3 tw-w-2/3">
			<process-model-stepper :current-step="2">
			</process-model-stepper>
			<!-- CARDS AREAS-->
			<div class="content-areas mt-3">
				<card-container>
					<v-layout  wrap align-center pa-5 class="">
						<v-btn
							fab
							dark
							depressed
							small
							color="info" class="arrow-container left"
							:style="`backgroud-color:${$appColors.info} !important`"
							:disabled="selectedCardIndex === 0"
							@click="scrollCard('left', null)">
							<v-icon dark size="40">keyboard_arrow_left</v-icon>
						</v-btn>
						<template>
							<v-flex xs12>
								<v-layout
									row
									style="gap: 10px"
									class="overflow-container"
									ref="scrollContainer">
									<div
										v-for="(area,indexArea) in areas"
										:key="indexArea"
										:class="{
											'selected-card': indexArea === selectedCardIndex
										}"
										class="card-container"
										@click="handleCardClick(indexArea)"
										>
										<div class="flex-container">
											<v-icon
												v-if="indexArea !== selectedCardIndex"
												color="success"
												:disabled="!area.isSelected"
											>
												check_circle
											</v-icon>
											<p
												v-if="area.name.length <= 30"
												class="tw-m-0 tw-text-center"
											>{{area.name}}</p>
											<p
												v-else
												class="tw-m-0 tw-text-center"
											>{{area.name | limitTo(30) }}</p>
										</div>
									</div>
								</v-layout>
							</v-flex>
						</template>
						<v-btn
							fab
							dark
							depressed
							small
							color="info" class="arrow-container right"
							:style="`backgroud-color:${$appColors.info} !important`"
							:disabled="selectedCardIndex === areas.length - 1"
							@click="scrollCard('right', null)">
							<v-icon dark size="40">keyboard_arrow_right</v-icon>
						</v-btn>
					</v-layout>
				</card-container>
			</div>
			<div class="nqt-container mt-3">
				<div v-if="showTable" class="table-header tw-flex tw-justify-between tw-items-center tw-p-3">
				<div class="rows-per-page-selector">
					<span class="tw-mr-2">Mostrar:</span>
					<v-select
						v-model="params.limit"
						:items="[10, 25, 50, 100, 500, 1000]"
						@change="changeLimit(params.limit)"
						class="limit-select"
						hide-details
						solo
						:menu-props="{ contentClass: 'limit-select-menu' }"
					></v-select>
					<span class="tw-ml-2">por página</span>
				</div>
				</div>
				<process-list-employee
					v-if="showTable"
					class="employeList mx-3"
					:rows="employees"
					:checkAll="checkAll"
					:total-items-visible="employees.length"
					:total-items="totalItems"
					:last-page="lastPage"
					:current-page="currentPage"
					:flag-num="flagNum"
					@on-page="changePage"
					@on-search-event="onSearchEvent"
					@row-is-selected="rowIsSelected"
					@selected-all="selectedAll"
					@changeSort="changeSort">
				</process-list-employee>
				<p-empty-message v-else>
					Selecciones un Área
				</p-empty-message>
				<div class="nqt-btn"
					:style="`border-top:1px solid ${$appColors.gray};`">
					<v-btn
						color="primary"
						class="btn-action"
						@click="returnPage"
					>
						Atrás
					</v-btn>
					<v-btn
						color="primary"
						class="btn-action"
						@click="saveProcessEmployee"
					>
						Siguiente
					</v-btn>
				</div>
			</div>
		</div>
		<div class="tw-w-1/3 px-3">
			<process-model-description-employees>
			</process-model-description-employees>
		</div>
	</div>
</template>

<script>
import processModelStepper from '@/modules/evaluation-360/components/process/process-model-stepper';
import processModelDescriptionEmployees from '@/modules/evaluation-360/components/process/process-model-description-employees';
import cardContainer from '@/components/shared/card-container';
import cardSelected from '@/modules/evaluation-360/components/evaluation/card-selected';
import processListEmployee from '@/modules/evaluation-360/components/process/process-list-employee';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import helper from '@/shared/helper';

import { pathOr } from 'ramda';

const { getLocalData } = helper;

function mounted() {
}

function beforeCreate() {
}

async function created() {
	if (this.process && this.process.processEmployees && this.process.processEmployees.length > 0) {
		this.employeeSavedInProcess = this.process.processEmployees.map(d => ({
			...d.employee,
			isSelected: true,
		}));
	} else {
		this.employeeSavedInProcess = [];
	}
	await this.ensureJobIds();
	this.loadDetails();
	this.idEditProcess = this.$route.params.id;
	if (this.idEditProcess) {
		this.loadProcess(this.idEditProcess);
	}
}

async function loadProcess(id) {
	try {
		const { data: response } = await this.$httpPraktiko.get(`process/detail/${id}`);
		this.$store.dispatch('evaluation360/assignProcess', response);
		await this.ensureJobIds();
	} catch (error) {
		this.showGenericError(error);
	}
}

/**
 * Re-deriva los jobIds cubiertos por el poll del proceso cuando el estado
 * (vuex/localStorage) se perdio: sin esto el listado de empleados se pide con
 * jobIds='' y el backend devuelve TODOS los empleados de la empresa, sin
 * respetar la cobertura de puestos de la evaluacion.
 */
async function ensureJobIds() {
	if (this.jobIds.length > 0) return;
	const pollId = pathOr(null, ['process', 'pollId'], this.$store.state.evaluation360);
	if (!pollId) return;
	try {
		const { data: polls } = await this.$http.get('polls?toolCode=E360&state=1');
		const foundPoll = (polls || []).find(p => p.id === pollId);
		const factorsWeight = pathOr([], ['factorsWeight'], foundPoll);
		const jobIds = [...new Set(
			factorsWeight.map(f => f.jobId).filter(id => id !== null && id !== undefined),
		)];
		if (jobIds.length > 0) {
			this.$store.dispatch('evaluation360/saveJobIds', jobIds);
		}
	} catch (error) {
		this.showGenericError();
	}
}

async function loadDetails() {
	try {
		const { data: details } = await this.$httpPraktiko.get(`process/detail/${this.process.id}`);
		this.areas = details.groups && details.groups.areas ? details.groups.areas : [];
		this.areas = this.areas.map((f) => {
			const newF = { ...f };
			newF.isSelected = false;
			return newF;
		});
		this.idEditProcess = this.$route.params.id;

		// Seleccionar automáticamente la primera área si existe
		if (this.areas.length > 0) {
			this.handleCardClick(0);
		}

		// Mostrar tabla después de cargar áreas
		this.showTable = true;
	} catch (error) {
		this.showGenericError();
	}
}


async function selectArea(value) {
	this.idAreas =	value;
	this.checkAll = false;
	delete this.params.customerId;
	const params = {
		params: { ...this.params },
	};
	params.params.jobIds = this.jobIds.join(',');
	if (value) {
		this.groupId = value;
		params.params.groupId = value;
	}
	const { data: response, headers, status } = await this.$httpPraktiko.get(`process/list-employees-group/${this.process.id}`, params);
	if (status === 200) {
		this.employees = response.results;
		this.selectedTrue = this.employees.filter(isSelc => isSelc.isSelected === true);
		this.areas = this.areas.map((a) => {
			const newA = { ...a };
			if (a.id === value) {
				newA.isSelected = this.selectedTrue.length > 0;
			}
			return newA;
		});

		// Obtener empleados ya guardados para esta área (de cualquier página)
		const employeesFromArea = this.employeeSelectByAreas
			.find(area => area.idArea === value);

		if (employeesFromArea && employeesFromArea.employeesFilter) {
			this.areaSaved = this.employeeSelectByAreas
				.map(employeeByArea => employeeByArea.idArea);
			const validateArea = this.areaSaved.includes(value);

			if (validateArea) {
				// El área ya tiene selecciones guardadas - usar esas
				this.employeeSelected = employeesFromArea.employeesFilter;
			} else {
				// Primera vez en esta área - agregar los pre-seleccionados del backend
				this.selectedTrue.forEach((empl) => {
					const exist = this.employeeSelected.some(emp => emp.id === empl.id);
					if (!exist) {
						this.employeeSelected.push(empl);
					}
				});
			}
			// Actualizar store con las selecciones actuales (de todas las páginas)
			this.$store.dispatch('evaluation360/updateEmployeesByArea', {
				idArea: value,
				employees: this.employeeSelected,
			});
		} else {
			// No hay datos previos en el store - primera vez absoluta
			// Agregar los pre-seleccionados del backend
			this.selectedTrue.forEach((empl) => {
				const exist = this.employeeSelected.some(emp => emp.id === empl.id);
				if (!exist) {
					this.employeeSelected.push(empl);
				}
			});
			// Guardar en el store
			this.$store.dispatch('evaluation360/updateEmployeesByArea', {
				idArea: value,
				employees: this.employeeSelected,
			});
		}

		// Marcar empleados de la página actual según employeeSelected (global)
		const selectedIds = new Set(this.employeeSelected.map(e => e.id));
		this.employees = this.employees.map(emp => ({
			...emp,
			isSelected: selectedIds.has(emp.id),
		}));

		this.checkAll = this.employees.every(e => e.isSelected);
		this.lastPage = Number(headers['x-last-page']);
		this.totalItems = Number(headers['x-quantity']);
	}
}

function changeSort({ fieldName, sortDirection }) {
	this.params.sortField = fieldName;
	this.params.sortDirection = sortDirection;
	this.selectArea();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.params.groupId = this.groupId;
	this.selectArea();
}

function changeLimit(newLimit) {
	this.params.limit = newLimit;
	this.params.page = 1;
	this.currentPage = 1;
	this.params.groupId = this.groupId;
	this.selectArea();
}

function onSearchEvent(search) {
	this.params.search = search.trim() || null;
	this.params.groupId = this.groupId;
	this.changePage(1);
}

function totalItemsVisible() {
	return this.employees.length;
}

function rowIsSelected(value) {
	const index = this.employeeSelected.findIndex(d => d.id === value.id);
	if (value.isSelected) {
		if (index === -1) {
			this.employeeSelected.push(value);
			this.$store.dispatch('evaluation360/updateEmployeesByArea', {
				idArea: this.idAreas,
				employees: this.employeeSelected,
			});
		}
	} else if (index > -1) {
		this.employeeSelected.splice(index, 1);
		this.$store.dispatch('evaluation360/updateEmployeesByArea', {
			idArea: this.idAreas,
			employees: this.employeeSelected,
		});
	}
	const decition = this.employees.some(e => e.id === value.id);
	const indexA = this.areas.findIndex(areas => areas.id === this.idAreas);
	const found = this.employees.some(obj1 =>
		this.employeeSelected.some(obj2 => obj1.id === obj2.id));
	if (indexA !== -1) {
		this.$set(this.areas[indexA], 'isSelected', found ? decition : false);
	}
	this.checkAll = this.employees.every(e => e.isSelected);
}

function selectedAll(value) {
	this.employees = this.employees.map((r) => {
		const newRow = { ...r };
		newRow.isSelected = value;
		return newRow;
	});
	this.checkAll = value;

	if (value) {
		// Seleccionar todos: agregar empleados de esta página a employeeSelected
		this.employees.forEach((empl) => {
			const exist = this.employeeSelected.some(emp => emp.id === empl.id);
			if (!exist) {
				this.employeeSelected.push(empl);
			}
		});
	} else {
		// Deseleccionar todos: remover SOLO empleados de esta página
		const currentPageIds = new Set(this.employees.map(e => e.id));
		this.employeeSelected = this.employeeSelected.filter(emp => !currentPageIds.has(emp.id));
	}

	this.$store.dispatch('evaluation360/updateEmployeesByArea', {
		idArea: this.idAreas,
		employees: this.employeeSelected,
	});
}

async function saveProcessEmployee() {
	try {
		const selectEmployee = this.employeeSelected.map((selectE) => {
			const newSelectE = {
				processId: this.process.id,
				employeeId: selectE.id,
				groupId: selectE.groupId,
				jobId: selectE.jobId,
			};
			return newSelectE;
		});
		const body = {
			evaluation: selectEmployee,
		};
		const processEmployee = await this.$httpPraktiko.patch(`process/employee/${this.process.id}`, body);
		this.showNotification('Proceso Generado Exitosamente');

		// Actualizar el proceso en el store con los empleados guardados
		const updatedProcess = {
			...this.process,
			processEmployees: processEmployee.data,
		};
		this.$store.dispatch('evaluation360/assignProcess', updatedProcess);

		if (this.idEditProcess) {
			this.goTo('edit-choose-evaluators');
		} else {
			this.goTo('process-choose-evaluators');
		}
	} catch (e) {
		if (e) {
			this.showGenericError();
		}
	}
}

function returnPage() {
	if (this.idEditProcess) {
		this.goTo('edit-configuration-process');
	} else {
		this.goTo('process-configuration-process');
		this.$store.dispatch('evaluation360/assignProcess', this.process);
	}
}

function scrollCard(direction, id, flag) {
	if (direction === 'left') {
		this.selectedCardIndex -= 1;
	} else if (direction === 'right') {
		this.selectedCardIndex += 1;
	}
	if (this.selectedCardIndex && this.selectedCardIndex < 0) {
		this.selectedCardIndex = 0;
	} else if (this.selectedCardIndex >= this.areas.length) {
		this.selectedCardIndex = this.areas.length - 1;
	}
	if (flag) {
		this.$nextTick(() => {
			const selectedCard = this.$refs.scrollContainer.querySelector(`.card-container:nth-child(${this.selectedCardIndex})`);
			selectedCard.scrollIntoView({ behavior: 'smooth' });
		});
	} else {
		this.showTable = true;
		if (!id) {
			this.selectArea(this.areas[this.selectedCardIndex].id);
		} else {
			this.selectArea(id);
		}
		const selectedCard = this.$refs.scrollContainer.querySelector(`.card-container:nth-child(${this.selectedCardIndex + 1})`);
		if (selectedCard !== null) {
			selectedCard.scrollIntoView({ behavior: 'smooth' });
		}
	}
}

function handleCardClick(index, flag = false) {
	if (flag) {
		this.selectedCardIndex = index;
	} else {
		this.showTable = true;
		this.selectedCardIndex = index;
		this.selectArea(this.areas[index].id);
	}
}

function data() {
	return {
		areas: [],
		employees: [],
		employeeSelected: [],
		areaEmployeeSelections: [],
		checkAll: false,
		idAreas: null,
		idEditProcess: null,
		areaSaved: [],
		employeeSavedInProcess: [],
		selectedCardIndex: 0,
		selectedTrue: [],
		params: {
			page: 1,
			limit: 10,
			sortField: null,
			sortDirection: null,
		},
		groupId: null,
		flagNum: 0,
		lastPage: 0,
		totalItems: 0,
		currentPage: 1,
		showTable: false,
	};
}

export default {
	name: 'page-choose-employees',
	mounted,
	beforeCreate,
	created,
	data,
	components: {
		processModelStepper,
		processModelDescriptionEmployees,
		cardContainer,
		processListEmployee,
		cardSelected,
		PEmptyMessage,
	},
	computed: {
		process() {
			const vuexProcess = pathOr(null, ['process'], this.$store.state.evaluation360);
			if (vuexProcess) {
				return vuexProcess;
			}
			return getLocalData('process');
		},
		jobIds() {
			const vuexJobIds = pathOr([], ['jobIds'], this.$store.state.evaluation360);
			if (vuexJobIds && vuexJobIds.length > 0) {
				return vuexJobIds;
			}
			const localJobIds = getLocalData('jobIds');
			return localJobIds && localJobIds.length > 0 ? localJobIds : [];
		},
		employeeData() {
			return pathOr(null, ['process', 'processEmployees'], this.$store.state.evaluation360);
		},
		employeeSelectByAreas() {
			return pathOr(null, ['employeesByAreas'], this.$store.state.evaluation360);
		},
		totalItemsVisible,
	},
	methods: {
		loadProcess,
		ensureJobIds,
		loadDetails,
		selectArea,
		rowIsSelected,
		selectedAll,
		saveProcessEmployee,
		returnPage,
		scrollCard,
		handleCardClick,
		changePage,
		changeLimit,
		onSearchEvent,
		changeSort,
	},
};
</script>

<style lang="scss" scoped>
.content-areas{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	background-color: map-get($colors, white);
	border-radius: 8px;
	.overflow-container {
		overflow-x: auto;
		background-color: map-get($colors, white);
		max-width: 100%;
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}
	.overflow-container::-webkit-scrollbar {
		width: 0;
	}

	.overflow-container::-webkit-scrollbar-thumb {
	background-color: transparent;
	}
	.card-container {
		display: flex;
		flex-direction: row;
		background: none;
		border: 2px solid map-get($colors, orange-dark);
		border-radius: 12px;
		cursor: pointer;
		padding: 11px;
		margin: 0;
		min-width: 170px;
		max-width: 170px;
		height: 85px;
		&:hover {
			border: 1px solid map-get($colors, orange-light);
		}

		&.active {
			background-color: map-get($colors, secondary);
		}

		&-line {
			margin: 10px 0;
			width: 70%;
		}

		&-text {
			font-size: 11px;
			text-transform: uppercase;
		}
		.flex-container {
			display: flex;
			align-items: center;
			justify-content: space-around;
			width: 100%;
		}
		p {
			font-weight: bold;
			color: map-get($colors, orange-dark);
		}

	}
	.card-container.selected-card {
		border-radius: 12px;
		background-color: map-get($colors, orange-dark);
		p {
			font-weight: bold;
			color: map-get($colors, white);
		}
	}
}
.pos-relative {
	position: relative;
}
.arrow-container {
	bottom: 0px;
	margin: auto;
	position: absolute;
	top: 0px;
	&.left {
		left: -21px;
	}
	&.right {
		right: -21px;
	}
}
.nqt-container {
	display: flex;
	flex-direction: column;
	justify-content: space-bewteen;
	width: 100%;
	border: 1px solid #E9E9E9;
	background-color: map-get($colors, white);
	border-radius: 8px;
	.nqt-btn {
		align-items: center;
		display: flex;
		justify-content: center;
		gap: 10px;
		padding: 20px 30px;
	}
	.table-header {
		background-color: map-get($colors, gray-light);
		border-bottom: 1px solid #E9E9E9;
	}
	.rows-per-page-selector {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: var(--app-color-info);
	.limit-select {
		max-width: 90px;
		padding: 0;
		margin: 0;
		::v-deep .v-input__control {
			min-height: 32px !important;
		}
		::v-deep .v-input__slot {
			min-height: 32px !important;
			border: 1px solid var(--app-color-primary) !important;
			border-radius: 4px !important;
			background-color: map-get($colors, white) !important;
			box-shadow: none !important;
			transition: border-color 0.2s ease;
			&:hover {
				border-color: map-get($colors, orange-dark) !important;
				cursor: pointer;
			}
		}
		::v-deep .v-select__selections {
			color: var(--app-color-info);
			font-size: 14px;
			padding: 0 8px !important;
			min-height: 30px !important;
		}
		::v-deep .v-input__append-inner {
			margin: 0 !important;
			padding-left: 0 !important;
		}
		::v-deep .v-icon {
			color: var(--app-color-primary);
			font-size: 18px;
		}
	}
	}
}
.employeList {
	@media (max-width: 950px) {
			width: 700px;
			display: flex;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/process-steps-pages/page-choose-employees.vue